import * as React from 'react';
import clsx from 'clsx';

import style from './labelComponent.module.scss';

interface LabelComponentProps {
  text: string;
  mandatory?: boolean | null;
  hideSpace?: boolean | null;
  className?: string | null;
}

export const LabelComponent: React.FunctionComponent<LabelComponentProps> = ({
  text,
  mandatory = false,
  hideSpace = false,
  className = null
}) => {
  return (
    <label htmlFor="name" className={clsx(style.labelContainer, className)}>
      {text}
      {hideSpace ? '' : ' '}
      {mandatory && <span>*</span>}
    </label>
  );
};

export default LabelComponent;
